:host {
  display: block;
  max-width: 100%;
}

.compliance-link {
  &::part(container) {
    display: inline;
  }
}

gz-labeled-content::part(content) {
  margin-top: -4px;
}

.showMore {
  float: right;
  margin-bottom: calc(var(--spacer) / 2);
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

.section-splitter {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
    margin-top: var(--spacer);


  &:nth-last-child(1 of .section-splitter):not(:first-of-type) {
    border: none;
  }

  gz-labeled-content {
    &:not(:nth-last-child(1 of gz-labeled-content), :nth-last-child(1 of gz-labeled-content):first-of-type)  {
      margin-bottom: calc(var(--spacer) * 2);
    }
  }
}

.compliance-element {
  height: 24px;
}

.dialogBody {
  width: 60%;
  margin: calc(var(--spacer) * 4);
}
